import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { io } from 'socket.io-client';

export const SocketContext = createContext(null);

export const Socket = ({ uri, options = {}, children }) => {
  const socketRef = useRef(null);

  if (!socketRef.current) {
    socketRef.current = io(uri, options);
  }

  useEffect(() => () => {
    if (socketRef.current) {
      socketRef.current.disconnect();
    }
  }, []);

  return (
    <SocketContext.Provider value={socketRef.current}>
      {children}
    </SocketContext.Provider>
  );
};

export const Event = ({ event, handler }) => {
  const socket = useContext(SocketContext);

  useEffect(() => {
    if (socket) {
      socket.on(event, handler);
      return () => socket.off(event, handler);
    }
    return undefined;
  }, [socket, event, handler]);

  return null;
};

